import {useSuspenseQuery} from '@tanstack/react-query';

import {api} from '@/lib/ky';

import {projectSchema} from '../utils/schemas/project';

import {projectKeys} from './queryKeys';

import type {
  ExtractFnReturnType,
  QueryConfig,
  QueryConfig2,
} from '@/lib/react-query';

export const getProject = async (id: string) => {
  const data = await api.get(`projects/${id}`).json();
  return projectSchema.parse(data);
};

export const useProject = (id: string, config?: QueryConfig<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: projectKeys.detail(id),
    queryFn: () => getProject(id),
  });
};
export const useProjectLoader = (config: QueryConfig2<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getProject;
